import { render, staticRenderFns } from "./PortcallberthsFormHeader.vue?vue&type=template&id=bf415bd0"
import script from "./PortcallberthsFormHeader.vue?vue&type=script&lang=js"
export * from "./PortcallberthsFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports